export default "__VITE_ASSET__BOtQRjAd__"